export interface ClientDocument {
  id: string;
  label: string;
  /** Путь к HTML-версии для отображения на сайте */
  href: string;
  /** Путь к DOCX-версии для скачивания */
  downloadHref: string;
}

// Обновите пути под реальные имена файлов в public/assets/documents
export const clientDocuments: ClientDocument[] = [
  {
    id: 'offer',
    label: 'Договор оферты',
    href: '/assets/documents/offer.html',
    // Ожидаемый файл: Договор оферты.docx
    downloadHref: '/assets/documents/Договор оферты.docx',
  },
  {
    id: 'personal-data',
    label: 'Согласие на обработку персональных данных',
    href: '/assets/documents/personal-data.html',
    downloadHref: '/assets/documents/Согласие на обработку персональных данных.docx',
  },
  {
    id: 'reglament',
    label: 'Регламент',
    href: '/assets/documents/reglament.html',
    // Ожидаемый файл: Регламент.docx
    downloadHref: '/assets/documents/Регламент.docx',
  },
  {
    id: 'tariffs',
    label: 'Тарифы',
    href: '/assets/documents/tariffs.html',
    downloadHref: '/assets/documents/Тарифы.docx',
  },
];

